import RecallDetail from "./recallDetails.container"

export default RecallDetail
